import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {MatExpansionPanel, MatExpansionPanelHeader} from '@angular/material/expansion';
import {MenuItem} from '../../smart/main-layout/navigation/menu-items';

@Component({
  selector: 'mc-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpansionPanelComponent implements AfterViewInit {
  @ViewChild('panelHeader') panelHeader: MatExpansionPanelHeader;
  @ContentChild('navItem', {read: ElementRef}) navItem: ElementRef<HTMLElement>;
  @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;
  @Input() panelNavItem: MenuItem;
  @Input() isExpanded: boolean;
  @Output() opened = new EventEmitter();
  @Input() disabled: boolean = false;

  ngAfterViewInit() {
    if (this.navItem) {
      this.disableFocusOnElm(this.panelHeader);
    }
    if (this.disabled) {
      this.expansionPanel.disabled = true;
      this.expansionPanel.hideToggle = true;
    }
  }

  private disableFocusOnElm(element: MatExpansionPanelHeader) {
    if (!element) {
      return;
    }
    element.tabIndex = -1;
  }
}
